import {Form, Input, Select, Slider} from "antd";
import React from "react";
const { Option } = Select;

export const portfolioNameInput = ()=>{
    return (
        <Form.Item
            name="name"
            label="Portfolio Name (this name will be used for all users using it)"
            rules={[{ required: true, message: 'Name is required' }]}
        >
            <Input size={'large'} />
        </Form.Item>
    )
}


export const portfolioDescription = ()=>{
    return (
        <Form.Item name={['attr', 'summary']} label={'Portfolio Description'}>
            <Input.TextArea size={'large'} />
        </Form.Item>
    )
}

export const benchmarkInput = ()=>{
    return (
        <Form.Item
            name="benchmark"
            label="Benchmark: Can be ETF (Ex SPY) or Blend e.g(spy70agg30)"
        >
            <Input size={'large'} />
        </Form.Item>
    )
}

export const targetAllocationSlider = ({equityAllocation, onSliderChange})=>{
    return (
        <Form.Item label="Target Allocation">
            <Slider
              marks={{ 0: '0%', 100: '100%' }}
              step={5}
              value={equityAllocation}
              onChange={onSliderChange}
              tooltipVisible
            />
            <div style={{ marginTop: 16 }}>
              Equity: {equityAllocation}%, Fixed Income: {equityAllocation===100?0:100-equityAllocation}%
            </div>
        </Form.Item>
    )
}

export const assetClassSelect = ()=>{
    return (
        <Form.Item
            name={['user_tags', 'asset_class']}
            label="Asset Class Category (Select Best Fit)"
          >
            <Select size={'large'}>
              <Option value="equity">Equity</Option>
              <Option value="fixed">Fixed Income</Option>
              <Option value="balanced">Balanced</Option>
              <Option value="alt">Alternative</Option>
            </Select>
        </Form.Item>
    )
}

export const regionSelect = ()=>{
    return (
        <Form.Item
            name={['user_tags', 'region']}
            label="Geographic Area of Focus"
          >
            <Select size={'large'}>
                <Option value="domestic">Domestic (US)</Option>
                <Option value="global">Global</Option>
                <Option value="ex_us">Global (Ex-US)</Option>
            </Select>
        </Form.Item>
    )
}


export const objectiveSelect = ()=>{
    return (
        <Form.Item
            name={['user_tags', 'objective']}
            label="Investment Objective"
          >
            <Select size={'large'}>
                <Option value="model">Model Portfolio</Option>
                <Option value="growth_tilt">Growth Tilt</Option>
                <Option value="value_tilt">Value Tilt</Option>
                <Option value="dividend">Dividend Income</Option>
                <Option value="low_vol">Low Volatility</Option>
                <Option value="thematic">Thematic</Option>

            </Select>
        </Form.Item>
    )
}

export const assetTypeSelect = ()=>{
    return (
        <Form.Item
            name={['user_tags', 'asset_type']}
            label="Asset Type"
          >
            <Select size={'large'}>
              <Option value="etf">ETF Only</Option>
              <Option value="stock">Single-Stock Only</Option>
              <Option value="mixed">ETF & Single-Stock Mixed</Option>
            </Select>
        </Form.Item>
    )
}


export const strategyTypeSelect = ()=>{
    return (
        <Form.Item
            name={['user_tags', 'strategy_type']}
            label="Strategy Type"
          >
            <Select size={'large'}>
              <Option value="passive">Passive</Option>
              <Option value="algo">Active (Algorithmic)</Option>
              <Option value="disc">Active (Tactical/Discretionary) </Option>
            </Select>
        </Form.Item>
    )
}




